module.exports = __webpack_public_path__ + "assets/img/c2.e8c5de7c.jpg";